export { default } from './shopReviewSlice';
